import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import lottie from 'lottie-web'

import { Button } from '../../common/button'

import { ampEvent } from '../../../utils/amplitude'
import { getIsLegalFlow } from '../../../redux/slices/userSlice'

import './styles.scss'

const Header = ({ setIsActiveModal }) => {
	const animationRef = useRef()
	const isLegalFlow = useSelector(getIsLegalFlow)

	const handleBuySubscription = () => {
		setIsActiveModal(true)
		ampEvent('Checkout_shown')
		document.body.style.overflow = 'hidden'
	}

	useEffect(() => {
		lottie.loadAnimation({
			container: animationRef.current,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: require('./animation.json'),
		})
	}, [])

	return (
		<div className="discount-header">
			<div
				className={`discount-header__animation ${isLegalFlow ? 'small' : ''}`}
				ref={animationRef}
			></div>
			{isLegalFlow ? (
				<>
					<h2 className="discount-header__title-legal">
						Start Your <br />
						<span className="pink-accent">3 Days Trial for $0.69</span>
					</h2>
				</>
			) : (
				<>
					<h2 className="discount-header__title">Nobody has it but you do!</h2>
					<img
						className="discount-header__price"
						src="images/discount/price.png"
					></img>
					<div className="discount-header__subtitle">
						With Refine, take super photos with never ending access to attract
						surprising shots
					</div>

					<Button
						className="discount-header__btn"
						buttonText="Get my Discount"
						onClick={handleBuySubscription}
					/>
					<div className="discount-header__payment-info-info">
						No charges for 3 days
						<br />
						Cancel anytime · $6.99/weekly
					</div>
				</>
			)}
		</div>
	)
}

export { Header }
